"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cyprusQrConfig = exports.defaultQrConfig = void 0;
var defaultQrConfig = {
    appStoreUrl: process.env.APP_STORE_URL || "",
    playStoreUrl: process.env.PLAY_STORE_URL || "",
    huaweiStoreUrl: process.env.HUAWEI_STORE_URL || "",
    deepLinkScheme: process.env.APP_DEEP_LINK_SCHEME || "",
    learnMoreUrl: process.env.LEARN_MORE_URL || "",
};
exports.defaultQrConfig = defaultQrConfig;
var cyprusQrConfig = {
    appStoreUrl: process.env.CYPRUS_APP_STORE_URL || "",
    playStoreUrl: process.env.CYPRUS_PLAY_STORE_URL || "",
    huaweiStoreUrl: process.env.CYPRUS_HUAWEI_STORE_URL || "",
    deepLinkScheme: process.env.CYPRUS_APP_DEEP_LINK_SCHEME || "",
    learnMoreUrl: process.env.CYPRUS_LEARN_MORE_URL || "",
};
exports.cyprusQrConfig = cyprusQrConfig;
